module.exports = __webpack_public_path__ + "media/img/pages/profile/hug fr 1-fcf0fe77740650025000a74286e8527c.jpg";